import { useAtom } from 'jotai';
import React, { Fragment, Suspense } from 'react';
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Collapse,
  Button,
} from 'reactstrap';

import { isMetricsSectionOpenAtom, metricsViewAtom } from './state';

import '../../styles.css';
import { ErrorBoundary } from 'components/Errors/ErrorBoundary';
import LoadingScreen from 'components/LoadingScreen';

import Charts from './charts';

import IconButton from 'components/IconButton';

import { MetricsView } from '../../types';

const VulnerabilityMetrics = () => {
  const [isMetricsSectionOpen, setIsMetricsSectionOpen] = useAtom(
    isMetricsSectionOpenAtom,
  );
  const [metricsView, setMetricsView] = useAtom(metricsViewAtom);

  return (
    <Fragment>
      <Card>
        <CardHeader>
          <Row>
            <Col className="col-auto">
              <CardTitle tag="h4">
                Vulnerability&nbsp;Metrics&nbsp;-&nbsp;
                {metricsView === MetricsView.Severity ? 'Severity' : 'Timeband'}
                <Button
                  outline={true}
                  color="primary"
                  size="sm"
                  onClick={() => setIsMetricsSectionOpen(!isMetricsSectionOpen)}
                >
                  <i
                    className={
                      isMetricsSectionOpen
                        ? 'bi bi-chevron-up'
                        : 'bi bi-chevron-down'
                    }
                  ></i>
                </Button>
              </CardTitle>
              {/* <CardSubtitle
                                className="mb-2 text-muted"
                                tag="h5"
                                >
                                {metricsView === MetricsView.Severity ? "Severity View" : "Timeband View" }
                            </CardSubtitle> */}
            </Col>
            <Col>
              <Collapse isOpen={isMetricsSectionOpen}>
                <div className="d-inline float-right">
                  <IconButton
                    id="metricsViewButton"
                    iconClass={
                      metricsView === MetricsView.Severity
                        ? 'fa fa-clock-four fa-lg'
                        : 'fa fa-chart-bar fa-lg'
                    }
                    tooltip={
                      metricsView === MetricsView.Severity
                        ? 'Time-Based View'
                        : 'Severity View'
                    }
                    onClick={() => {
                      setMetricsView(
                        metricsView === MetricsView.Severity
                          ? MetricsView.Time
                          : MetricsView.Severity,
                      );
                    }}
                  />
                </div>
              </Collapse>
            </Col>
          </Row>
        </CardHeader>
        <Collapse isOpen={isMetricsSectionOpen}>
          <CardBody>
            <ErrorBoundary>
              <div className="row">
                <Suspense fallback={<LoadingScreen />}>
                  {isMetricsSectionOpen && <Charts />}
                </Suspense>
              </div>
            </ErrorBoundary>
          </CardBody>
        </Collapse>
      </Card>
    </Fragment>
  );
};

export default VulnerabilityMetrics;
